import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {createHashFromUnderline} from 'utils/utils';

import './AnchorsSection.less';

const smoothScroll = (element) => {
    const offsetTop = element.getBoundingClientRect().top + window.pageYOffset;
    window.scroll({
        top: offsetTop,
        behavior: 'smooth',
    });
};

const AnchorsSection = ({currentHash, sections}) => {
    const links = sections
        .map((section) => {
            return createHashFromUnderline(section);
        })
        .filter((i) => i);

    const initialActive = links.findIndex(
        (item) => currentHash === `#${item.hash}`,
    );

    const [active, updateActive] = useState(
        initialActive > -1 ? initialActive : 0,
    );
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        require('smoothscroll-polyfill').polyfill();
    }, []);

    if (!sections || sections.length < 1) {
        return null;
    }

    const handleLinkClick = (event, index) => {
        const id = links[index].hash;
        const element = document.getElementById(id);

        if (element) {
            event.preventDefault();
            smoothScroll(element);
            updateActive(index);

            if (window.history.pushState) {
                window.history.pushState(null, null, `#${id}`);
            } else {
                window.location.hash = id;
            }
        }
    };

    if (links.length < 1) {
        return null;
    }

    return (
        <div className="AnchorsSection article-content-container">
            <nav className="AnchorsSection__navbar" role="navigation">
                <ul className="AnchorsSection__list" role="tablist">
                    {links.map((link, index) => {
                        const isActive =
                            isClient && active === index
                                ? 'AnchorsSection__link AnchorsSection__link--active'
                                : 'AnchorsSection__link';
                        return (
                            <li className="AnchorsSection__item" key={index}>
                                <a
                                    href={`#${link.hash}`}
                                    className={isActive}
                                    onClick={(e) => handleLinkClick(e, index)}
                                >
                                    {link.label}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </div>
    );
};

AnchorsSection.propTypes = {
    currentHash: PropTypes.string.isRequired,
    sections: PropTypes.arrayOf(PropTypes.object),
};

export default AnchorsSection;
